import { useSelector } from "react-redux";
import groupBy from "lodash.groupby";
import useGoTo from "./useGoTo";
import { getGroupAvailability, getProductAvailability } from "./useWorkingTime";
import filterProductsBySearch from "../utils/searchProducts";

/**
 * O cardápio que as homes mostram (delivery, POS, totem e a tela de grupo):
 * só produtos disponíveis agora, filtrados pela busca e agrupados, e só os
 * grupos disponíveis que ficaram com algum produto.
 */
export function buildMenuCatalog(groups, products, searchText, now) {
  const availableProducts = products.filter(
    (p) => getProductAvailability(p, now).isAvailable,
  );
  const matchedProducts = filterProductsBySearch(availableProducts, searchText);
  const productsByGroup = groupBy(matchedProducts, "groupId");
  const visibleGroups = groups.filter(
    (g) => productsByGroup[g.id] && getGroupAvailability(g, now).isAvailable,
  );

  return { availableProducts, matchedProducts, productsByGroup, visibleGroups };
}

export default function useMenuCatalog(searchText = "") {
  const goTo = useGoTo();
  const { groups, items } = useSelector((state) => state.products);
  const catalog = buildMenuCatalog(groups, items, searchText);
  const onProductSelect = (productId) => goTo(`/product/${productId}`);

  return { ...catalog, onProductSelect };
}
